<template>
      <div id="company">
				<section>
					<!-- h2 class="large">特集から探す</h2>
					<ul class="list_special">
          <li>
            <router-link :to="{ name: 'catlist', params: { Name: '新入荷'}}"><img src="/images/special01.jpg"><label>新入荷商品</label></router-link>
          </li>
          <li>
            <router-link :to="{ name: 'catlist', params: { Name: 'おすすめ'}}"><img src="/images/special02.jpg"><label>おすすめ商品</label></router-link>
          </li>
          <li>
            <router-link :to="{ name: 'catlist', params: { Name: '災害'}}"><img src="/images/special03.jpg"><label>災害支援商品</label></router-link>
          </li>
          </ul -->

					<h3><span class="h3_line"><span class="h3_deco"></span>機種一覧から探す</span></h3>
					<ul class="list_category">
          <li>
            <router-link :to="{ name: 'speclist', params: { Spec: 'ゴルフ場関連機器'}}">
            <img :src="baseUrl + 'img/top/category01.jpg'"><label>ゴルフ場関連機器</label></router-link>
          </li>
          <li>
            <router-link :to="{ name: 'speclist', params: { Spec: '造園関連機器'}}">
            <img :src="baseUrl + 'img/top/category02.jpg'"><label>造園関連機器</label></router-link>
          </li>
          <li>
            <router-link :to="{ name: 'speclist', params: { Spec: '季節商品'}}">
            <img :src="baseUrl + 'img/top/category03.jpg'"><label>季節商品</label></router-link>
          </li>
          </ul>
        </section>
				<!--
        <section>
          <h3 class="mt3em"><span class="h3_line"><span class="h3_deco"></span>参考資料</span></h3>
          <ul class="list_document">
            <li>
              <a href="/../document/general-conditions.html"><img src="/img/catalog/rental.jpg"><label>レンタル約款</label></a>
            </li>
            <li>
              <a href="/../document/rental-support.html"><img src="/img/catalog/support.jpg"><label>レンタル物件サポート特約制度</label></a>
            </li>
            <li>
              <a href="/../document/special-contract.html"><img src="/img/catalog/guarantee.jpg"><label>レンタル保障制度</label></a>
            </li>
            <li>
              <a href="/../document/law.html"><img src="/img/catalog/law.jpg"><label>法規</label></a>
            </li>
            <li>
              <a href="/../document/qualification.html"><img src="/img/catalog/certificate.jpg"><label>資格</label></a>
            </li>
            <li>
              <a href="/../document/unit.html"><img src="/img/catalog/unit.jpg"><label>単位</label></a>
            </li>
            <li>
              <a href="/../document/guide.html"><img src="/img/catalog/guide.jpg"><label>ご利用ガイド</label></a>
            </li>
          </ul>
        </section>
				-->
      </div>
</template>

<script>
  export default {
    data: function () {
      return {
        baseUrl: process.env.BASE_URL || '/'
      }
    },
    mounted: function (){
      this.$parent.category_id = null
    },
    methods: {
    },
    watch: {
    }
  }
</script>
